export default () => (
	<div class="rias-content col-span-full mx-auto px-4 pb-8">
		<h1 class="headline-lg mb-6">Privacy Policy</h1>

		<div class="space-y-6 text-gray-700 leading-relaxed">

			<p>
				This Privacy Policy sets out how the Home Energy and Data Services Ltd uses and protects any information that you give us when using RIAS-regs, including this website. We ask that you read this privacy notice carefully as it contains important information on how and why we collect, store, use and share personal information, your rights in relation to your personal information and on how to contact us and supervisory authorities in the event you have a complaint.
			</p>

			<p>
				Home Energy and Data Services Ltd is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement. When we collect and use personal information about you, we do so under the General Data Protection Regulation (GDPR) which applies across the European Union (including in the United Kingdom) and we are responsible as &#8220;controller&#8221; of that personal information for the purposes of those laws.
			</p>

			<p>Please do not send us any personal information if you do not want that information to be used in this way.</p>

			<p>
				Home Energy and Data Services Ltd. may change this Policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes. This Policy is effective from 25th May 2018.
			</p>

			<section>
				<h2 class="font-semibold text-xl mb-2">What we collect</h2>
				<p class="mb-3">We may collect the following information:</p>
				<ul class="list-disc pl-6 space-y-1">
					<li>name and job title</li>
					<li>contact information including email address</li>
					<li>address and postcode</li>
				</ul>
			</section>

			<section>
				<h2 class="font-semibold text-xl mb-2">What we do with the information we gather</h2>
				<p class="mb-3">
					We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
				</p>
				<ul class="list-disc pl-6 space-y-1 mb-3">
					<li>to provide and improve our services to you</li>
					<li>to process and respond to inquiries</li>
					<li>
						to communicate with you periodically by bulletin/notices about new products, special offers or other information which we think you may find interesting using the email address which you have provided
					</li>
					<li>internal record keeping</li>
				</ul>

				<p class="mb-3">
					We are required to hold the personal information of Approved Certifiers of Design and Certification Coordinators in perpetuity. For all others who have registered and/or subscribed, but never been approved we will remove your information on request.
				</p>

				<p class="mb-3">
					Under the GDPR, most commonly, we will use your personal information where it is necessary:
				</p>

				<ul class="list-disc pl-6 space-y-1 mb-3">
					<li>to perform the contract we have entered into with you</li>
					<li>to comply with a legal obligation</li>
					<li>for our legitimate interests</li>
				</ul>

				<p>
					Although this will be rare, it may be necessary for Home Energy and Data Services Ltd to obtain your consent from time to time for processing certain personal information. If so, we will seek your consent for that in accordance with the GDPR rules.
				</p>
			</section>

			<section>
				<h2 class="font-semibold text-xl mb-2">Keeping your personal information secure</h2>
				<p>
					We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
				</p>
			</section>

			<section>
				<h2 class="font-semibold text-xl mb-2">How we use cookies</h2>
				<p>
					A cookie is a small file which asks permission to be placed on your computer&#8217;s hard drive. Once you agree, the file is added, and the cookie helps analyse web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.
				</p>
				<p>
					We use traffic log cookies to identify which pages are being used. This helps us analyse data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.
				</p>
				<p>
					Overall, cookies help us provide you with a better website by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
				</p>
				<p>
					You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
				</p>
			</section>

			<section>
				<h2 class="font-semibold text-xl mb-2">Links to other websites</h2>
				<p>
					Our website may contain links to other websites of interest. However, once you have used these links to leave our site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement. You should exercise caution and look at the privacy statement applicable to the website in question.
				</p>
			</section>

			<section>
				<h2 class="font-semibold text-xl mb-2">Controlling your personal information</h2>
				<p>
					We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.
				</p>
			</section>

			<section>
				<h2 class="font-semibold text-xl mb-2">Your rights</h2>
				<p class="mb-3">
					Under the GDPR you have a number of important rights to access your personal information free of charge. In summary, those include rights to:
				</p>

				<ul class="list-disc pl-6 space-y-1 mb-3">
					<li>access your personal information which this Privacy Notice has described above</li>
					<li>require us to correct any mistakes in your information which we hold</li>
					<li>require the erasure of personal information concerning you in certain situations</li>
					<li>receive the personal information concerning you in certain situations</li>
					<li>
						receive the personal information concerning you which you have provided to us, in a structure, commonly used and machine-readable format and have the right to transmit this data to a third party in certain situations
					</li>
					<li>object at any time to processing of personal information concerning you for direct marketing</li>
					<li>
						object to decisions being taken by automated means which produce legal effects concerning you or similarly significantly affecting you
					</li>
					<li>object in certain other situations to our continued processing of your personal information</li>
					<li>otherwise restrict our processing of your personal information in certain circumstances</li>
				</ul>

				<p class="mb-2">If you would like to exercise any of those rights, please:</p>

				<ul class="list-disc pl-6 space-y-1">
					<li>email our Data Protection Officer at support@home-data.co.uk</li>
					<li>let us have enough information to identify you</li>
					<li>
						let us have proof of your identity and address (a copy of your driving license or passport and a recent utility or credit card bill)
					</li>
					<li>let us know the information to which your request relates</li>
				</ul>
			</section>

			<section>
				<h2 class="font-semibold text-xl mb-2">How to complain</h2>
				<p>
					We hope that our Data Protection Officer can resolve any query or concern you raise about our use of your information.
				</p>
				<p>
					The GDPR also gives you the right to lodge a complaint with a supervisory authority, in particular in the European Union state where you work, normally live or where any alleged infringement of data protection laws occurred. The supervisory authority in the UK is the Information Commissioner who may be contacted at https://ico.org.uk/concerns/ or 0303 123 1113.
				</p>
			</section>
		</div>
	</div>
);